<template>
  <q-route-tab
    to="/escalated"
    name="escalated"
    :label="label"
    exact
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import { matches, status } from '@/social/post/post';
import postRepository from '@/social/post/post-repository';
import eventBus from '@/messaging/event-bus';
import {
  PostEscalated,
  PostTrashed,
  PostRestored,
  PostResolved,
} from '@/messaging/events';

interface Data {
  total: number,
  filters: PostFilters
}

export default defineComponent({
  data(): Data {
    return {
      total: -1,
      filters: {
        statuses: [status.ESCALATED],
        socialSiteIds: [],
        isTrashed: false,
        since: null,
        until: null,
      },
    };
  },
  computed: {
    label(): string {
      if (this.total === -1) return 'Escalated';
      return `Escalated (${this.total})`;
    },
  },
  methods: {
    load() {
      postRepository.count(this.filters).then((total) => {
        this.total = total;
      });
    },
    decrement() {
      this.total -= 1;
    },
    increment() {
      this.total += 1;
    },
    onPostTrashed(e: PostTrashed) {
      const post = Object.assign({}, e.post, { isTrashed: false });
      if (matches(post, this.filters)) this.decrement();
    },
    onPostRestored(e: PostRestored) {
      if (matches(e.post, this.filters)) this.increment();
    },
  },
  created() {
    eventBus.$on(PostEscalated.eventName, this.increment);
    eventBus.$on(PostResolved.eventName, this.decrement);
    eventBus.$on(PostTrashed.eventName, this.onPostTrashed);
    eventBus.$on(PostRestored.eventName, this.onPostRestored);
    this.load();
  },
  beforeUnmount() {
    eventBus.$off(PostEscalated.eventName, this.increment);
    eventBus.$off(PostResolved.eventName, this.decrement);
    eventBus.$off(PostTrashed.eventName, this.onPostTrashed);
    eventBus.$off(PostRestored.eventName, this.onPostRestored);
  },
});
</script>
